import get from 'lodash/get';
import { checkAccess } from 'app/actions/app.actions';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import roles from 'app/validators/roles';
import * as api from 'user/resources/user.api';
import retailerSettingsTemplate from './retailer-settings.html';

const DIRTY_FORM = 'retailerSettings';

const mapStateToThis = ({ session }) => {
  const { retailer, role } = session;
  const { isChainHead } = retailer;

  return {
    retailer,
    isChainHead,
    role,
  };
};

const mapDispatchToThis = {
  checkAccess,
  setDirtyForm,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Notifications')
class RetailerSettingsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.DIRTY_FORM = DIRTY_FORM;
    this.canChangeSelfRegistrationEnabled = this.checkAccess('retailer.canChangeSelfRegistrationEnabled');
    this.canSaveRetailerSettings = this.checkAccess('retailer.settings');
    this.primaryUserRole = get(roles, 'PRIMARY_USER_ROLES[0]');
    this.enableDisable = [
      {
        label: this.gettextCatalog.getString('Enable'),
        value: true,
      },
      {
        label: this.gettextCatalog.getString('Disable'),
        value: false,
      },
    ];
    this.selfRegistration = {};
    const result = await api.fetchSelfRegistrationSettings(this.retailer.retailerId);
    this.selfRegistration.selfRegistrationEnabled = result.canSelfRegister;
    this.selfRegistration.subordinateSelfRegistrationEnabled = result.subordinatesCanSelfRegister;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onSave(form) {
    form.$setSubmitted();
    this.saveConfiguration();
  }

  async saveConfiguration() {
    try {
      this.form.$setPristine();

      await api.saveSelfRegistrationSettings(this.selfRegistration.subordinateSelfRegistrationEnabled, this.retailer.retailerId);
      this.setDirtyForm(this.DIRTY_FORM, false);
      this.Notifications.showAlert(this.gettextCatalog.getString('Success!'));
    } catch (error) {
      console.error('RETAILER_SETTING', error);
      this.Notifications.showAlert(this.gettextCatalog.getString('Failed!'));
    }
  }

  cancel() {
    if (this.$state.previous.name) return this.$state.go(this.$state.previous);
    return this.$state.go('dashboard-summary');
  }
}

export default class RetailerSettingsComponent {
  constructor() {
    this.template = retailerSettingsTemplate;
    this.controller = RetailerSettingsController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/components/retailer-settings/retailer-settings-component.js